export default "__VITE_ASSET__D3Co8huQ__"